import { gql } from "@apollo/client"

export const GET_LICENSE_POOLS = gql`
  query getLicensePools($data: GetLicensePoolsInput!) {
    licensePool {
      getLicensePools(data: $data) {
        licensePools {
          id
          orgId
          orgType
          seatCount
          startDate
          endDate
          createdAt
          updatedAt
          createdBy
          isDeleted
          schoolName
          districtName
        }
        pagination {
          page
          pageSize
          totalCount
          count
          hasNextPage
          hasPrevPage
        }
      }
    }
  }
`

export const GET_LICENSE_POOL = gql`
  query getLicensePool($id: String!) {
    licensePool {
      getLicensePool(id: $id) {
        id
        orgId
        orgType
        seatCount
        startDate
        endDate
        createdAt
        updatedAt
        createdBy
        isDeleted
        schoolName
        districtName
      }
    }
  }
`
